<template>
  <div class="gto-dashboard gtopradash">
    <div class="gtopradash_content">
      <div class="gtopradash_top">
        <div class="gtopradash_top_left">
          <h1
            class="text-mega weight_600"
            v-html="$t('practice_dashboard.title')"
          ></h1>
          <!-- <h2
            v-html="$t('practice_dashboard.title_sub')"
            class="text-normal mt-4 weight_500 clr-grey"
          ></h2> -->
        </div>
        <div class="gtopradash_top_right">
          <div
            class="gtopradash_img anim-fade-in"
            :style="`--anim-duration: 1.2s;`"
          >
            <PcScreensSvg />
          </div>
        </div>
      </div>
      <div class="gtopradash_bottom">
        <div class="gtopradash_tiles">
          <!-- i.pathName === 'PracticeStats' || -->
          <router-link
            v-for="(item, iIdx) in links_practice_all.filter(
              i =>
                i.pathName === 'PracticeTrainer' ||
                (!mobile && i.pathName === 'PracticeRangeBuilder') ||
                i.pathName === 'PracticeSessions' ||
                i.pathName === 'PracticeStats' ||
                i.pathName === 'PracticeDrills' ||
                i.pathName === 'PracticeHands',
            )"
            :key="`${item.name}_${iIdx}`"
            :to="{ name: item.pathName, query: item.query || {} }"
            :class="{ 'no-events': item.disabled }"
            class="gtopradash_tiles_tile"
            :data-tst="`practice_dashboard_link_${item.pathName}`"
          >
            <!-- class="navcard_dashboard-v2" -->
            <NavCard
              class="navcard_dashboard"
              :item="item"
              :style="`
          --anim-duration:${iIdx * 0.15}s;
          ${item.tag_live ? tagLiveStyle : ''};
           --clr-icon-back:${item.clr_secondary};
           --clr-title-hover:${item.clr_secondary};
           --clr-icon:var(--clr-black-1);
           --clr-icon-hover:var(--clr-black-1);
           --clr-back:rgb(30, 30, 30, 0.7);
           --clr-sub:var(--clr-grey-2);
           --icon-radius: 8px;
           --icon-size: 2.875rem;
           --icon-font-size: 2.125rem;
          ${item.style};
           `"
              :hasSub="true"
              :hasTag="item.pathName === 'PracticeTrainer' ? item.tag_live : true"
              :class="[iIdx === 0 ? 'anim-fade-in' : 'anim-fade-in-timed']"
            />
          </router-link>
        </div>

        <PracticeHandsTotals
          :hasFilters="false"
          :hasTypes="false"
          :statsHasEvStats="false"
          :hasGtoScoreTrendChart="false"
          class="prahndsttls_totals_stats-inline anim-fade-in-timed mt-4"
          style="
            --anim-duration: 0.6s;
            grid-gap: 2rem;
            --clr-stats-back: transparent;
            --clr-stats-chart-back: var(--clr-black-1-3);
          "
        >
          <!-- @click="$router.push({ name: 'PracticeStats' })" -->
          <template #stats_title>
            {{ ' ' }}
          </template>
        </PracticeHandsTotals>
      </div>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'
import PcScreensSvg from '@/assets/svg/pcscreens.svg'
import PracticeHandsTotals from '@/components/PracticeHandsTotals/PracticeHandsTotals'

export default {
  name: 'PracticeDashboard',
  components: {
    PcScreensSvg,
    PracticeHandsTotals,
  },
  mixins: [links_mix],
  data() {
    this.tagLiveStyle = `
        --tag-padding:0 0.25rem;--clr-tag:var(--clr-white-0); --clr-tag-back: var(--clr-error);
        `
    return {}
  },

  computed: {
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
  },
}
</script>
<style lang="scss" scoped>
.gtopradash {
  // background: var(--clr-black-0-2);

  display: grid;
  overflow: auto;
  align-items: center;
  justify-content: center;
  max-height: var(--vh-3);
  width: 100%;
  // flex: 1;
  padding: 0 0 1rem 0;
  &_content {
    display: flex;
    flex-direction: column;
    max-width: 95rem;
    // overflow: auto;
    width: 100vw;
    padding: 2rem 1rem;
    margin-top: 4rem;
    // margin: 0 auto;
  }
  &_top {
    margin: 8rem 0 0 0;
    position: relative;
    z-index: 1;
    display: flex;
    &_left {
      z-index: 2;
      position: relative;
      flex: 1;
    }
    &_right {
      z-index: 1;
      position: absolute;
      height: 100%;
      width: 100%;
    }
  }
  &_bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    align-content: flex-start;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;
    margin: 8rem 0 4rem 0;
  }

  &_tiles {
    width: 100%;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(3, 1fr);
    &_tile {
      // width: 100%;
      // height: 100%;
      display: flex;
      .navcard {
        flex: 1;
      }
    }
  }
  &_totals {
    width: 100%;
    // margin: 2rem 0 0 0;
  }
  &_img {
    z-index: 1;
    position: absolute;
    // filter: brightness(55%);
    right: 8%;
    top: -100%;
    height: clamp(28rem, 36rem, 40vw);
    // height: 100%;
    svg {
      width: 100%;
      height: 100%;
    }
  }
}
.logo {
  color: var(--clr-black-1);
  fill: currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  // height: 3rem;
  flex-shrink: 0;
  margin-top: 2rem;
  &_icon {
    font-size: 12rem;
    color: var(--clr-black-1);
  }
}

@media (max-width: 1023px) {
  .gtopradash {
    &_content {
    }
    &_top {
      &_left {
      }
      &_right {
      }
    }
    &_bottom {
    }
    &_tiles {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 1rem;
      &_tile {
        width: 100%;
      }
    }
    &_totals {
    }
    &_img {
      svg {
      }
    }
  }
}

@media (max-width: 450px) {
  .gtopradash {
    &_content {
    }
    &_top {
      &_left {
      }
      &_right {
      }
    }
    &_bottom {
    }
    &_tiles {
      grid-template-columns: repeat(1, 1fr);
    }
    &_totals {
    }
    &_img {
      svg {
      }
    }
  }
}
</style>
